export enum Environment {
  DEV = "dev",
  PRODUCTION = "prod",
}
